<template>
  <div
    v-if="props.isOpen"
    :class="bem('')"
  >
    <VisionIconButton
      icon="cross"
      size="small"
      :class="bem('close-button')"
      @click="handleClose"
    />
    <div
      :class="bem('inner')"
      :style="
        props.video?.video && {
          aspectRatio: `${props.video?.video?.width}/${props.video?.video?.height}`,
        }
      "
    >
      <div :class="bem('video-container')">
        <BaseVideo
          v-if="props.type === 'embed'"
          :video="props.video.video"
          :will-autoplay="false"
          :full-width="false"
          :is-muted="false"
          :class="bem('video')"
        />
        <ExternalVideoEmbed
          v-else-if="props.type === 'external'"
          :video="props.video"
          :class="bem('video')"
        />
      </div>
    </div>
    <div
      :class="bem('backdrop')"
      @click="handleClose"
    />
  </div>
</template>

<script setup lang="ts">
interface MediaOverlayProps {
  type: string
  button?: any
  video: any
  isOpen: boolean
}

const props = withDefaults(defineProps<MediaOverlayProps>(), {
  isOpen: false,
  type: '',
  button: '',
  video: '',
})
const bem = useBEM('MediaOverlay')

const emits = defineEmits(['close'])

const handleClose = function () {
  emits('close')
}
</script>

<style lang="postcss">
.MediaOverlay {
  @apply isolate fixed top-0 left-0 w-screen h-[100dvh]
  z-[9999] p-[var(--outer-gutter)]
  flex items-center justify-center;
}

.MediaOverlay__backdrop {
  @apply absolute cursor-pointer z-0 inset-0 backdrop-blur-dark;
}

.MediaOverlay__inner {
  @apply w-full max-h-full h-full flex items-center justify-center z-[1];
}

.MediaOverlay__video-container {
  @apply relative h-full max-h-full max-w-full flex items-center justify-center
  object-contain aspect-video;
}

.MediaOverlay__video {
  @apply absolute max-w-full max-h-full px-0 mx-0
  flex overflow-clip rounded-lg;

  mux-player {
    --media-object-fit: contain;
  }
}

.MediaOverlay__close-button {
  @apply absolute top-4 right-4 z-10;
}
</style>
